import { getAccountId } from 'redux/actions/accountActions'
import { handleErrors, handleErrorsWithCode } from './AssetController'

/**
 * 
 * @param {*} withApiKey If true include x-api-key
 * @returns 
 */
export const getNFTServiceHeaders = (withApiKey) => {
    let headers = {
        'Content-Type': 'application/json',
        'x-user-id': getAccountId(true)
    }
    if (withApiKey) {
        headers = { ...headers, 'x-api-key': process.env.REACT_APP_API_KEY }
    }
    return headers
}

/**
 * 
 * @param {*} tokenId          a uint256 string tokenId 
 * @param {*} mediaHash 
 * @param {*} name 
 * @param {*} description 
 * @param {*} messageId 
 * @param {*} price             A Gwei string
 * @returns 
 */
export const addNFT = async (tokenId, mediaHash,name, description, messageId, price) => {
    const url = `${process.env.REACT_APP_NFT_SERVICE}nft/add`
    return fetch(url, {
        method: 'POST',
        headers: getNFTServiceHeaders(),
        body: JSON.stringify({ tokenId, mediaHash,name, description, messageId, price }),
    })
        .then(handleErrors)
        .then(() => {
            console.log('...started transaction')
            return true
        })
}

export const deleteNFT = async (tokenId) => {

}

/**
 * 
 * @param {*} tokenId 
 * @returns 
 */
export const getNFT = async (tokenId) => {
    const url = `${process.env.REACT_APP_NFT_SERVICE}nft/get/${tokenId}`
    return fetch(url, {
        method: 'GET',
        headers: getNFTServiceHeaders()
    })
        .then(handleErrorsWithCode)
        .then((res) => res.json())
        .then((nft) => {
            return nft
        })
}

/**
 * 
 * @param {*} messageId 
 * @returns 
 */
export const getNFTForMessage = async (messageId) => {
    const url = `${process.env.REACT_APP_NFT_SERVICE}nft/getByMessage/${messageId}`
    return fetch(url, {
        method: 'GET',
        headers: getNFTServiceHeaders()
    })
        .then(handleErrorsWithCode)
        .then((res) => res.json())
        .then((nft) => {
            return nft
        })
}

export const startNFTTransaction = async (tokenId, txHash) => {
    const url = `${process.env.REACT_APP_NFT_SERVICE}nft/startNFTTransaction`
    return fetch(url, {
        method: 'POST',
        headers: getNFTServiceHeaders(),
        body: JSON.stringify({ tokenId, txHash }),
    })
        .then(handleErrors)
        .then(() => {
            console.log('...started transaction')
            return true
        })
}